<div
  fxFlexFill
  fxLayout="column">
  
  <!-- Toolbar -->
  <div>
    <mat-toolbar fxLayout="row" fxLayoutAlign="space-between center">
      <!-- Record Count -->
      <div 
        fxLayout="column" 
        fxFlex="noshrink"
        fxLayout.gt-sm="row" 
        fxLayoutAlign="start start" 
        [class.compact-header-text]="media.isActive('lt-sm')"
        >
        
        <span class="mat-body-1 padding-right-2" [style.font-size.px]="media.isActive('lt-sm') ? '12' : '14'">
          {{ 'LABEL_RECORD_COUNT' | translate }}
        </span>

        <span class="mat-body-1" [style.font-size.px]="media.isActive('lt-sm') ? '12' : '14'">
          {{ recordCount }}
        </span>
      </div>

      <div fxLayout fxLayoutAlign="end center">
        <!-- Search Bar -->
        <form 
          novalidate           
          autocorrect="off"
          [formGroup]="form"           
          autocomplete="off"
          >

          <mat-form-field 
            floatLabel="never" 
            class="max-width-160"
            [style.font-size.px]="media.isActive('lt-sm') ? '12' : '14'"
            >

            <input 
              matInput 
              #searchTerm
              formControlName="searchTerm"
              [placeholder]="'LABEL_SEARCH' | translate"
              >

            <mat-icon 
              matSuffix
              color="primary"
              class="clear-input"
              svgIcon="close-circle"
              *ngIf="searchTerm.value"
              [matTooltip]="'LABEL_CLEAR' | translate"
              (click)="form.get('searchTerm').setValue('')"
              >
            </mat-icon>
          </mat-form-field>
        </form>

        <!-- Filter -->
        <button *ngIf="hasFilter" fxHide fxShow.gt-sm="true" [class.filter-color]="filterNumber > 0" mat-icon-button [matTooltip]="'LABEL_FILTER' | translate" (click)="filterList()" [disabled]="modifying">
          <mat-icon svgIcon="filter-variant"></mat-icon>
        </button>
        
        <!-- Refresh -->
        <button fxHide fxShow.gt-sm="true" mat-icon-button [matTooltip]="'LABEL_REFRESH' | translate" (click)="refreshList()" [disabled]="modifying">
          <mat-icon svgIcon="refresh"></mat-icon>
        </button>

        <!-- Add -->
        <button
          mat-icon-button
          (click)="add()" 
          [disabled]="modifying" 
          fxHide fxShow.gt-sm="true"
          [matTooltip]="'LABEL_ADD_NEW' | translate: { type: type | translate }"
          *ngIf="authService.hasPermission(moduleCode + constants.PERMISSION_STRINGS.add)"
          >
          <mat-icon svgIcon="plus-circle-outline"></mat-icon>
        </button>

        <!-- Upload Only -->
        <button
          mat-icon-button
          (click)="inputFile.click()" 
          [disabled]="modifying" 
          fxHide fxShow.gt-sm="true"
          [matTooltip]="'LABEL_UPLOAD' | translate"
          *ngIf="authService.hasPermission(moduleCode + constants.PERMISSION_STRINGS.upload) && !authService.hasPermission(moduleCode + constants.PERMISSION_STRINGS.download)"
          >
          <mat-icon svgIcon="cloud-upload"></mat-icon>
        </button>

        <!-- Download Only -->
        <button
          mat-icon-button
          (click)="exportXlsx()" 
          [disabled]="modifying" 
          fxHide fxShow.gt-sm="true"
          [matTooltip]="'LABEL_DOWNLOAD' | translate"
          *ngIf="!authService.hasPermission(moduleCode + constants.PERMISSION_STRINGS.upload) && authService.hasPermission(moduleCode + constants.PERMISSION_STRINGS.download)"
          >
          <mat-icon svgIcon="cloud-download"></mat-icon>
        </button>

        <!-- Mat Menu when Viewing in small screens -->
        <button 
          mat-icon-button 
          [matMenuTriggerFor]="menu"
          *ngIf="(authService.hasPermission(moduleCode + constants.PERMISSION_STRINGS.upload) && authService.hasPermission(moduleCode + constants.PERMISSION_STRINGS.download)) || media.isActive('lt-md')">
          <mat-icon svgIcon="dots-vertical"></mat-icon>
        </button>
        
        <mat-menu #menu="matMenu" fxHide.gt-sm="true">

          <button 
            mat-menu-item  
            *ngIf="hasFilter"
            fxShow.gt-sm="false"
            (click)="filterList()"
            [disabled]="modifying"
            [class.filter-color]="filterNumber > 0"
            >
            <mat-icon svgIcon="filter-variant"></mat-icon>
            <span> {{ 'LABEL_FILTER' | translate }} </span>
          </button>

          <button 
            mat-menu-item             
            fxShow.gt-sm="false"
            [disabled]="modifying"
            (click)="refreshList()"
            >
            <mat-icon svgIcon="refresh"></mat-icon>
            <span> {{ 'LABEL_REFRESH' | translate }} </span>
          </button>

          <button 
            mat-menu-item 
            (click)="add()" 
            fxShow.gt-sm="false"
            [disabled]="modifying"
            *ngIf="authService.hasPermission(moduleCode + constants.PERMISSION_STRINGS.add)"
            >
            <mat-icon svgIcon="plus-circle-outline"></mat-icon>
            <span> 
              {{ 'LABEL_ADD_NEW' | translate: { type: type | translate } }}
            </span>
          </button>

          <!-- upload submenu trigger -->
          <button 
            mat-menu-item 
            [matMenuTriggerFor]="uploadMenu"
            *ngIf="authService.hasPermission(moduleCode + constants.PERMISSION_STRINGS.upload) && hasUlSubMenu"
            >
            <span>{{ 'LABEL_UPLOAD' | translate}}</span>
          </button>

          <!-- download submenu trigger -->
          <button 
            mat-menu-item 
            [matMenuTriggerFor]="downloadMenu"
            *ngIf="authService.hasPermission(moduleCode + constants.PERMISSION_STRINGS.download) && hasDlSubMenu"
            >
            <span>{{ 'LABEL_DOWNLOAD' | translate}}</span>
          </button>

          <button 
            mat-menu-item 
            (click)="inputFile.click()" 
            *ngIf="authService.hasPermission(moduleCode + constants.PERMISSION_STRINGS.upload) && !hasUlSubMenu" 
            >
            <mat-icon svgIcon="cloud-upload"></mat-icon>
            <span>{{ 'LABEL_UPLOAD' | translate}}</span>
          </button>

          <button 
            mat-menu-item 
            (click)="exportXlsx()" 
            *ngIf="authService.hasPermission(moduleCode + constants.PERMISSION_STRINGS.download) && !hasDlSubMenu"
            >
            <mat-icon svgIcon="cloud-download"></mat-icon>
            <span>{{ 'LABEL_DOWNLOAD' | translate}}</span>
          </button>
        </mat-menu>

        <!-- group upload sub-menu -->
        <mat-menu #uploadMenu="matMenu">
          <button 
            mat-menu-item
            (click)="inputFile3.click()" 
            >
            <mat-icon svgIcon="cloud-upload"></mat-icon>
            <span>{{ 'LABEL_UPLOAD' | translate}} {{ 'LABEL_GROUP' | translate }}</span>
          </button>

          <button 
            mat-menu-item
            (click)="inputFile2.click()" 
            >
            <mat-icon svgIcon="cloud-upload"></mat-icon>
            <span>{{ 'LABEL_UPLOAD' | translate}} {{ 'LABEL_MAPPING' | translate }}</span>
          </button>
        </mat-menu>

        <!-- group download sub-menu -->
        <mat-menu #downloadMenu="matMenu">
            <button 
            mat-menu-item
            (click)="exportXlsx('master')"
            >
            <mat-icon svgIcon="cloud-download"></mat-icon>
            <span>{{ 'LABEL_DOWNLOAD' | translate}} {{ 'LABEL_GROUP' | translate }}</span>
          </button>

          <button 
            mat-menu-item
            (click)="exportXlsx('mapping')"
            >
            <mat-icon svgIcon="cloud-download"></mat-icon>
            <span>{{ 'LABEL_DOWNLOAD' | translate}} {{ 'LABEL_MAPPING' | translate }}</span>
          </button>

          <button 
            mat-menu-item
            (click)="exportXlsx('master'); exportXlsx('mapping')"
            >
            <mat-icon svgIcon="cloud-download"></mat-icon>
            <span>{{ 'LABEL_DOWNLOAD' | translate}} {{ 'LABEL_BOTH' | translate }}</span>
          </button>
        </mat-menu>
      </div>

      <input class="display-none" #inputFile type="file" (change)="helper.chooseFile($event, inputFile, uploadColumns, folderName)" hidden="true" accept=".xlsx">

      <input class="display-none" #inputFile2 type="file" (change)="helper.chooseFile($event, inputFile2, uploadTemplateColumns2, folderName2)" hidden="true" accept=".xlsx">

      <input class="display-none" #inputFile3 type="file" (change)="helper.chooseFile($event, inputFile3, uploadTemplateColumns, folderName)" hidden="true" accept=".xlsx">
    </mat-toolbar>
  </div>
  
  <!-- Data List -->
  <div 
    fxFlex
    class="overflow-auto"
    [class.disable]="modifying"
    *ngIf="!loadError && listData?.length"
    infiniteScroll
    (scrolled)="getMoreData()"
    [scrollWindow]="false"
  >
 
    <table mat-table [dataSource]="listData">
      <ng-container *ngFor="let col of displayedColumns; let colIndex = index" matColumnDef="{{col}}">
        <th mat-header-cell *matHeaderCellDef>{{ helper.displayHeader(col, moduleCode) | translate | titlecase | translate }}</th>
        <td mat-cell *matCellDef="let element">
          <!-- {{ col == 'is_active' ? (element[col] == 1 ? ('LABEL_ACTIVE' | translate) : ('LABEL_INACTIVE' | translate) ) : element[col] }} -->
          {{ helper.displayFields(element, col, moduleCode) | translate }}
        </td>
      </ng-container>
    
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="!modifying && getDetail(row)" [class.selected]="row?.id == selectedData?.id"></tr>
    </table>
  </div>
  
  <!-- Display if error -->
  <div  
    fxFlex
    fxLayout="column"
    fxLayoutGap="20px" 
    fxLayoutAlign="center center"
    *ngIf="loadError && !loading && !listData?.length">
  
    <mat-icon color="warn" svgIcon="alert-circle-outline" class="size-48"></mat-icon>
  
    <span class="mat-body">
      {{ 'MSG_ERROR_NETWORK_CONNECTION' | translate }}
    </span>
  
    <button color="primary" mat-raised-button (click)="refreshList()">
      {{ 'LABEL_REFRESH' | translate }}
    </button>
  </div>
  
  <!-- Display if no data fetched -->
  <div 
    fxFlex
    fxLayout="column"
    fxLayoutAlign="center center"
    *ngIf="!loadError && !loading && !listData?.length">
  
    <mat-icon color="primary" svgIcon="information-outline" class="size-48"></mat-icon>
  
    <span class="mat-body">
      {{ 'LABEL_NO_DATA' | translate}}
    </span>
  </div>

</div>